import {Injectable} from '@angular/core';
import {from, Observable} from 'rxjs';
import {ModalService} from '../core/modal.service';
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {ConfirmationDialogComponent} from './shared/confirmation-dialog/confirmation-dialog.component';

export interface IConfirmation {
    message: string;
    warning?: boolean;
    title?: string;
    confirm?: string;
    cancel?: string;
    customConfirm?: string | boolean
    customCancel?: string | boolean
    showActionButtons?: boolean
}

@Injectable({
    providedIn: 'root'
})
export class ConfirmationService {

    constructor(private modal: ModalService) {
    }

    confirm$(message: string | IConfirmation): Observable<any> {
        const modal: NgbModalRef = this.modal.open(ConfirmationDialogComponent, {
            ariaDescribedBy: 'confirmation-modal-body',
            ariaLabelledBy: 'confirmation-modal-title'
        });
        const instance: ConfirmationDialogComponent = modal.componentInstance;


        if (typeof message === 'string') {
            instance.message = message;
        } else {
            if (message.message) {
                instance.message = message.message;
            }
            if (message.cancel) {
                instance.cancelBtn = message.cancel;
            }
            if (message.confirm) {
                instance.confirmBtn = message.confirm;
            }
            if (message.title) {
                instance.title = message.title;
            }
            if (message.warning !== undefined) {
                instance.warning = message.warning;
            }
            if (message.customConfirm) {
                instance.customConfirm = message.customConfirm;
            }
            if (message.customCancel) {
                instance.customCancel = message.customCancel;
            }

            if (typeof message.showActionButtons === 'boolean') {
                instance.showActionButtons = message.showActionButtons;
            }
        }
        return from(modal.result.catch(() => false));
    }
}
